import { DataBean } from "../DataBean";

export class SpareInventoriedType extends DataBean {

  public async getSpareInventoriedTypeCatalogPorPropiedades( properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getSpareInventoriedTypeCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteSpareInventoriedType (idSpareInventoriedType: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteSpareInventoriedType_Number",
      [idSpareInventoriedType]
    );
  }

  public async updateSpareInventoriedType(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.SpareInventoriedType_updateSpareInventoriedType_com.orange.finance.processcontract.bean.SpareInventoriedType",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.SpareInventoriedType",
        },
      ]
    );
  }
}
